import { useNavigate, useParams } from 'react-router-dom'
import PageTitle from '../../../components/PageTitle'
import { useEffect } from 'react'
import { userFactory } from '../../../factories/UserFactory'
import { Card, Col, Descriptions, Divider, Row, Space, Typography } from 'antd'
import { User } from '../../../components/user/User'

const { Title } = Typography
const ContactPage = () => {
  const { userId } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    if (Number.isNaN(userId)) {
      navigate('/list')
      return
    }
  }, [userId])
  const user = userFactory.build()

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Space className="align-items-center">
          <User.Avatar model={user} type="condensed" size={35} />
          <Title className="m-0" level={3}>{`${user.name}`}</Title>
        </Space>
        <Divider style={{ marginBottom: 5 }} />
      </Col>
      <Col sm={10} xs={24}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Space direction="vertical" className="w-full">
              <PageTitle
                level={5}
                title={'User informations'}
                showButton={false}
              />
              <Card>
                <Descriptions column={2} layout="vertical" size="small">
                  <Descriptions.Item label="Full name">
                    {user.name}
                  </Descriptions.Item>
                  <Descriptions.Item label="Email">
                    {user.email}
                  </Descriptions.Item>
                  <Descriptions.Item label="Phone">
                    {user.phone}
                  </Descriptions.Item>
                </Descriptions>
              </Card>
            </Space>
          </Col>
          <Col span={24}>
            <Space direction="vertical" className="w-full">
              <PageTitle
                level={5}
                title={'Registerd comany'}
                showButton={false}
              />
              <Card>company où qu&apos;il est rataché</Card>
            </Space>
          </Col>
        </Row>
      </Col>
      <Col sm={14} xs={24}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Space direction="vertical" className="w-full">
              <PageTitle level={5} title={'Answers'} showButton={false} />
              <Card>Réponses aux forms</Card>
            </Space>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default ContactPage
